import IconButton from '@/global/components/Button/IconButton'
import { cn } from '@/lib/utils'
import {
    formatPorcentagemRegra,
    minutesToHours as hr,
    hoursToMinutes as min,
} from '@acme/common'
import { Divider } from '@mui/material'
import { InfoIcon } from 'lucide-react'
import React from 'react'
import Menu from './MenuV2'

type TKey = 'Parciais' | 'Integrais' | 'Justificadas' | 'Injustificadas'

type TipoFaltas = {
    [key in TKey]: string | undefined
}

interface IPropsSaldo {
    title: React.ReactNode
    extras?: string
    faltas?: string
    porcentagens?: { [key: string]: string }
    porcentagensNoturnas?: { [key: string]: string }
    tipoFaltas?: TipoFaltas
    sx?: React.CSSProperties
    underline?: boolean
}

export default function SaldoBox({
    extras = '00:00',
    faltas = '00:00',
    porcentagens = {},
    porcentagensNoturnas = {},
    tipoFaltas = {
        Parciais: '00:00',
        Integrais: '00:00',
        Justificadas: '00:00',
        Injustificadas: '00:00',
    },
    title,
    sx,
    underline,
}: IPropsSaldo) {
    const exibirTiposFaltas =
        faltas !== '00:00' &&
        Object.values(tipoFaltas).some(v => !!v && v !== '00:00')

    return (
        <div
            style={sx}
            className="flex gap-1 items-center border rounded-sm py-0.5 px-2"
        >
            <span
                className={cn(
                    'text-sm font-semibold text-nowrap text-right',
                    underline ? 'underline' : 'decoration-inherit',
                )}
            >
                {title}
            </span>
            <Divider orientation="vertical" flexItem />
            <div>
                <div className="text-nowrap text-sm font-normal flex gap-1">
                    {`Extras: ${extras}`}
                    <Menu.Root position="top-center" arrow>
                        {(!!Object.keys(porcentagens).length ||
                            !!Object.keys(porcentagensNoturnas).length) && (
                            <Menu.Trigger>
                                <IconButton
                                    size="small"
                                    className="size-fit p-0 inline-flex items-center -mt-0.5"
                                >
                                    <InfoIcon className="size-4" />
                                </IconButton>
                            </Menu.Trigger>
                        )}
                        <Menu.List>
                            {Object.entries(porcentagens).map(
                                ([key, valor]) => (
                                    <Menu.Item
                                        key={key}
                                        className="flex justify-between gap-4 cursor-default"
                                    >
                                        <span className="text-nowrap">
                                            Horas extras{' '}
                                            {formatPorcentagemRegra(key)}:
                                        </span>
                                        <span className="text-nowrap">
                                            {hr(min(valor))}
                                        </span>
                                    </Menu.Item>
                                ),
                            )}
                            {Object.entries(porcentagensNoturnas).map(
                                ([key, valor]) => (
                                    <Menu.Item
                                        key={`noturno_${key}`}
                                        className="flex justify-between gap-4 cursor-default"
                                    >
                                        <span className="text-nowrap">
                                            Horas extras noturno{' '}
                                            {formatPorcentagemRegra(key)}:
                                        </span>
                                        <span className="text-nowrap">
                                            {hr(min(valor))}
                                        </span>
                                    </Menu.Item>
                                ),
                            )}
                        </Menu.List>
                    </Menu.Root>
                </div>
                <div className="text-nowrap text-sm font-normal flex gap-1">
                    {`Faltas: ${faltas}`}
                    <Menu.Root position="top-center" arrow>
                        {exibirTiposFaltas && (
                            <Menu.Trigger>
                                <IconButton
                                    size="small"
                                    className="size-fit p-0 inline-flex items-center -mt-0.5"
                                >
                                    <InfoIcon className="size-4" />
                                </IconButton>
                            </Menu.Trigger>
                        )}
                        <Menu.List>
                            {Object.entries(tipoFaltas).map(([key, valor]) => (
                                <Menu.Item
                                    key={key}
                                    className="flex justify-between gap-4 cursor-default"
                                >
                                    <span className="text-nowrap">
                                        Faltas {key}:
                                    </span>
                                    <span className="text-nowrap">
                                        {valor || '00:00'}
                                    </span>
                                </Menu.Item>
                            ))}
                        </Menu.List>
                    </Menu.Root>
                </div>
            </div>
        </div>
    )
}
